/**
 * Get displayed modal
 * @return null || modal
 */

const getDisplayedModal = state => state.modal.displayedModal;

export default getDisplayedModal;

